@if (loading()) {
	<nz-spin nzSimple nzSize="large"></nz-spin>
} @else {
	<app-setup-wizard-dynamic-table
		[enableEditButton]="enableEditButton()"
		[enableToggleDisableButton]="enableToggleDisableButton()"
		[enableRemoveButton]="enableRemoveButton()"
		[enableResetButton]="enableResetButton()"
		[selectedRow]="selectedRow()"
		[rows]="rows()"
		[pageSize]="pageSize()"
		[columns]="columns()"
		(onToggleDisable)="onToggleDisableClick($event)"
		(onRemove)="onRemoveClick($event)"
		(onReset)="onResetClick($event)"
		(onEdit)="onEditClick($event)"
	>
		<!-- Header templates (defines order/keys) -->
		<ng-template [appHeaderColumn]="UnitCsvKeys.ssoUnitId">
			{{ UNIT_CSV_LABELS[UnitCsvKeys.ssoUnitId] }}
		</ng-template>
		<ng-template [appHeaderColumn]="UnitCsvKeys.defaultLangId">
			{{ UNIT_CSV_LABELS[UnitCsvKeys.defaultLangId] }}
		</ng-template>
		<ng-template [appHeaderColumn]="UnitCsvKeys.displayOrder">
			{{ UNIT_CSV_LABELS[UnitCsvKeys.displayOrder] }}
		</ng-template>
		<ng-template [appHeaderColumn]="UnitCsvKeys.enName">
			{{ UNIT_CSV_LABELS[UnitCsvKeys.enName] }}
		</ng-template>
		<ng-template [appHeaderColumn]="UnitCsvKeys.active">
			{{ UNIT_CSV_LABELS[UnitCsvKeys.active] }}
		</ng-template>

		<ng-template appHeaderColumn="status">Status</ng-template>

		<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
		<ng-template [appRowColumn]="UnitCsvKeys.ssoUnitId" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="UnitCsvKeys.ssoUnitId"></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="UnitCsvKeys.defaultLangId" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="UnitCsvKeys.defaultLangId"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="UnitCsvKeys.displayOrder" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="UnitCsvKeys.displayOrder"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="UnitCsvKeys.enName" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="UnitCsvKeys.enName"></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="UnitCsvKeys.active" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="UnitCsvKeys.active"></app-setup-wizard-before-after>
		</ng-template>

		<ng-template appRowColumn="status" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after-status [data]="row"></app-setup-wizard-before-after-status>
		</ng-template>
	</app-setup-wizard-dynamic-table>
}
